// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================AgGrid===================
import { AgGridReact } from 'ag-grid-react';

// ==================react Hook===================
import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

// ==================Actions===================
import {
  // setPageValue,
  setSaveFilesSelected,
  setSaveFilesSelectedPageFile,
} from '../../../actions/file';
import { setBtnExport } from '../../../actions/menuButton';

// ==================Components===================
import ButtonValue from './ButtonValue';
import ModalFileNoData from '../../ModalFileNoData';

// ==================Column definition===================
const columns = [
  {
    field: 'file_name',
    headerName: 'File Name',
    headerCheckboxSelection: true,
    checkboxSelection: true,
    suppressMenu: true,
    // sort: 'asc',
    minWidth: 330,
    cellRenderer: (params) => <ButtonValue val={params.value} />,
    flex: 0.9,
  },
  {
    field: 'data_center_acronyme',
    minWidth: 50,
    headerName: 'Data Center Acronyme',
    suppressMenu: true,
    flex: 0.7,
  },
  {
    field: 'reference_date',
    minWidth: 50,
    headerName: 'Reference Date',
    flex: 0.8,
  },
  {
    field: 'published_date',
    minWidth: 50,
    headerName: 'Published Date',
    flex: 0.8,
  },
  {
    field: 'revision_date',
    minWidth: 50,
    headerName: 'Revision Date',
    flex: 0.8,
  },
  {
    field: 'file_type',
    minWidth: 50,
    headerName: 'File Type',
    suppressMenu: true,
    flex: 0.5,
  },
  {
    field: 'sampling_window',
    minWidth: 50,
    headerName: 'Sampling Window',
    flex: 0.5,
  },
  {
    field: 'sampling_frequency',
    minWidth: 50,
    headerName: 'Sampling Frequency',
    flex: 0.5,
  },
  {
    field: 'file_size',
    minWidth: 50,
    headerName: 'File Size',
    suppressMenu: true,
    flex: 0.5,
  },
  {
    field: 'md5_check_sum',
    minWidth: 50,
    headerName: 'M D5 Check Sum',
    suppressMenu: true,
    flex: 1.5,
  },
  {
    field: 'status',
    minWidth: 50,
    headerName: 'Status',
    suppressMenu: true,
    flex: 0.3,
  },
];

function FileGrid() {
// ==============use Hook========================
  const dispatch = useDispatch();

  const filesData = useSelector((state) => state.files.dataFiles);

  const filesGrid = useSelector((state) => state.files.filesGrid);

  const btnExport = useSelector((state) => state.menuButton.btnExport);

  const filesSelected = useSelector((state) => state.files.grid.filesSelected);

  // const page = useSelector((state) => state.files.page);

  // ============== UseMemo ========================

  // default properties of each column
  const defaultColDef = useMemo(() => ({
    minWidth: 100,
    sortable: true,
    resizable: true,
  }), []);

  // ==================Refs===================
  const gridRef = useRef();

  // ============== UseCallback ========================

  // creation of a table with the data of each selected line saved in the state
  const onSelectionChanged = useCallback((event) => {
    const filesSelect = event.api.getSelectedNodes();
    const filesSelectedArray = [];
    filesSelect.map((el) => filesSelectedArray.push(el.data));
    dispatch(setSaveFilesSelected(filesSelectedArray));

    const rowSelected = event.api.getSelectedNodes();
    const arrayToSave = [];
    rowSelected.forEach((el) => {
      const dataToPush = filesData.find((el2) => el.data.file_name === el2.name);
      arrayToSave.push(dataToPush);
    });
    dispatch(setSaveFilesSelectedPageFile(arrayToSave));
  });

  // useEffect triggering each time the export csv button is clicked to trigger
  //  the library function to download the csv of the selected lines
  useEffect(() => {
    if (btnExport === true) {
      dispatch(setBtnExport(false));
      if (filesSelected.length === 0) {
        gridRef.current.api.exportDataAsCsv();
      }
      else if (filesSelected.length > 0) {
        gridRef.current.api.exportDataAsCsv({ onlySelected: true });
      }
    }
  }, [btnExport]);

  return (
    <>
      <div className="ag-theme-alpine fileDataGrid grid-wrapper">
        <div className="metadataGrid--height">
          <AgGridReact
            ref={gridRef}
            className="multipleFilesDataGrid"
            columnDefs={columns}
            rowData={filesGrid}
            defaultColDef={defaultColDef}
            rowSelection="multiple"
            suppressScrollOnNewData
            rowHeight={50}
            onSelectionChanged={onSelectionChanged}
            rowMultiSelectWithClick
            suppressRowClickSelection
          />
        </div>
      </div>
      <div className="totalItems">Total Files: {filesGrid.length} {((filesSelected.length > 0) && (filesSelected[0] !== undefined)) && ` (selected file(s): ${filesSelected.length})`}</div>
      <ModalFileNoData />
    </>
  );
}

export default FileGrid;
